import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import CallIcon from "../Assets/mobile.png";
import WhatsappIcon from "../Assets/whatsapp_color.png";
import Styles from "./SupportContactModal.module.css";

export default function SupportContactModal({ show, onClose, phone }) {
  const handleCall = () => {
    window.location.href = `tel:${phone}`;
  };

  const handleWhatsapp = () => {
    window.open(`https://wa.me/${phone}`, "_blank");
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      contentClassName={Styles.modalContent}
    >
      <Modal.Header closeButton>
        <Modal.Title>Contact Support</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className={Styles.actionContainer}>
          <button
            className={`${Styles.actionBtn} ${Styles.call}`}
            onClick={handleCall}
          >
            <img className={Styles.icon} src={CallIcon} alt="DialPad" />
            <span>Call</span>
          </button>

          <button
            className={`${Styles.actionBtn} ${Styles.whatsapp}`}
            onClick={handleWhatsapp}
          >
            <img className={Styles.icon} src={WhatsappIcon} alt="Whatsapp" />
            <span>WhatsApp</span>
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
